import type { IContentsData } from '../../types';
import { createSliceSteamup } from '../common';

interface IContentState {
  list: IContentsData[];

}

const allContentsManageSlice = createSliceSteamup(
  'allContentsDetailManage',
  {
    list: [],
  } as IContentState,

);

export default allContentsManageSlice;
